import LegalLayout from "./LegalLayout";

const S = ({ n, title, children, testid }) => (
  <section data-testid={testid} className="mt-12">
    <h2 className="font-display text-xl font-medium tracking-tight text-white">
      <span className="mr-3 text-sm font-light text-cyan-300/70">{n}</span>
      {title}
    </h2>
    <div className="mt-4 space-y-4 text-sm leading-relaxed text-[#C5CBD5]">{children}</div>
  </section>
);

export default function FairUsePolicy() {
  return (
    <LegalLayout title="Fair Use Policy" updated="Last updated: October 2026" testid="fair-use-page">
      <S n="01" title="Purpose" testid="fairuse-s1">
        <p>
          This Fair Use Policy explains acceptable and unacceptable use of the AIROBOTCAMSTUDIO
          platform, which is currently in development. It forms part of the Terms of Service and
          applies to this website now and to the future service when it launches.
        </p>
      </S>

      <S n="02" title="Acceptable Use" testid="fairuse-s2">
        <p>
          The platform is being built for personal, lawful, interactive AI entertainment. Use it
          respectfully, lawfully and in the spirit it is offered: real-time conversation and
          interaction with fictional AI characters for your own enjoyment.
        </p>
      </S>

      <S n="03" title="Prohibited Conduct" testid="fairuse-s3">
        <p>You must not:</p>
        <ul className="list-disc space-y-2 pl-5">
          <li>Engage in unlawful activity of any kind;</li>
          <li>Harass, abuse, threaten or exploit any person, or use the platform to facilitate such behaviour;</li>
          <li>Commit or attempt fraud, deception or impersonation;</li>
          <li>Attempt to bypass or compromise platform security, access controls or technical measures;</li>
          <li>Use bots, scripts or other automation for excessive automated usage, or scrape the service where prohibited;</li>
          <li>Interfere with platform infrastructure or introduce malicious software;</li>
          <li>Misuse AI characters, including attempting to generate or distribute unlawful content through them;</li>
          <li>Engage in activity that materially disrupts the service for other users.</li>
        </ul>
      </S>

      <S n="04" title="Enforcement" testid="fairuse-s4">
        <p>
          We may warn, restrict, suspend or terminate access where we reasonably believe this
          policy has been breached, and we may report unlawful activity to relevant authorities.
          Where practical, we will act proportionately and explain the reason for any action taken.
        </p>
      </S>

      <S n="05" title="Changes and Contact" testid="fairuse-s5">
        <p>
          This policy may evolve as the platform develops; the current version will always be
          available on this page. Questions: info@airobotcamstudio.com or
          airobotcamstudio@gmail.com. AIROBOTCAMSTUDIO LTD, UK Company No. 17410621, 71–75 Shelton
          Street, Covent Garden, London, United Kingdom, WC2H 9JQ.
        </p>
      </S>
    </LegalLayout>
  );
}
